import MQTT from 'paho-mqtt';

import { DOMAIN } from '../domain/main';

const PORT = 8084;
const RECONNECT_INTERVAL_MILLISECOND = 10000;

class MqttService {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  mqtt: any;
  client: string = '';
  password: string = '';

  setClient = (client: string) => (this.client = client);

  setPassword = (password: string) => (this.password = password);

  connect = () => {
    if (this.mqtt && this.mqtt.isConnected()) {
      this.disconnect();
    }

    if (this.client) {
      const clientId = this.client;
      const password = this.password;
      this.mqtt = new MQTT.Client(DOMAIN.BROKER_URL, PORT, clientId);
      this.mqtt.connect({
        userName: 'USER',
        password,
        useSSL: true,
        onSuccess: this.onConnectSuccess,
        onFailure: this.onConnectFailure,
        cleanSession: false,
        mqttVersion: 4,
      });
      this.mqtt.onMessageArrived = this.onMessageArrived;
      this.mqtt.onConnectionLost = this.onConnectionLost;
    }
  };

  disconnect = () => {
    console.log('disconnect mqtt');
    this.mqtt.disconnect();
  };

  onConnectSuccess = () => {
    console.log('success connect mqtt');
    const topic = `/user/v1/${this.client}`;
    this.mqtt.subscribe(topic);
  };

  onConnectFailure = (error: any) => {
    console.log(`MQTT onConnectFailure : ${error.errorMessage}`);
  };

  onActionCallBack = (mqttAction: any) => {
    console.log(`MQTT onMessageArrived: ${mqttAction.action}`);
  };

  onMessageArrived = (message: any) => {
    const mqttAction = JSON.parse(message.payloadString);
    console.log(`MQTT onMessageArrived : ${mqttAction.action}`);
    this.onActionCallBack(mqttAction);
  };
  onConnectionLost = (error: any) => {
    if (error.errorCode !== 0) {
      console.log(`MQTT onConnectionLost : ${error.errorMessage}`);
      // 斷線後 10 秒後自動重連一次
      const id = setTimeout(() => {
        this.connect();
        clearInterval(id);
      }, RECONNECT_INTERVAL_MILLISECOND);
    }
  };
}

export default MqttService;
